import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChapterRadioButtonData, TimeTrackingMethod } from '@app/+onboarding/chapters/chapter.model';
import { OnboardingChapterModule } from '@app/+onboarding/chapters/components/chapter.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'time-tracking-tracking-method',
  standalone: true,
  imports: [OnboardingChapterModule, TranslateModule],
  templateUrl: './time-tracking-tracking-method.component.html',
})
export class TimeTrackingTrackingMethodComponent {
  public timeTrackingMethod = new FormControl();

  public timeTrackingMethods: ChapterRadioButtonData[] = [
    {
      value: TimeTrackingMethod.SELF_CLOCKING,
      label: this.translate.instant('Allow employees to clock in and out'),
      description: this.translate.instant(
        'The most hands-off option. Employees record their own hours for maximum accuracy and accountability.',
      ),
    },
    {
      value: TimeTrackingMethod.COPY_FROM_SCHEDULE,
      label: this.translate.instant('Copy shifts from your schedule'),
      description: this.translate.instant(
        'A quicker option. Timesheets are pre-filled from shifts in your schedule, great for when employees stick closely to their assigned hours.',
      ),
    },
    {
      value: TimeTrackingMethod.MANUAL,
      label: this.translate.instant('Manually track hours worked'),
      description: this.translate.instant(
        'You (or your employees) manually enter worked hours, giving you the most flexibility, but also requiring the most effort.',
      ),
    },
  ];

  @Input()
  public nextButtonLoading: boolean;

  @Output()
  public next = new EventEmitter<TimeTrackingMethod>();

  public onNext() {
    if (this.timeTrackingMethod.value) {
      this.next.emit(this.timeTrackingMethod.value);
    }
  }

  public constructor(private translate: TranslateService) {}
}
